import { useContext } from 'react';

import NotificationContext from './NotificationContext';

export default () => useContext(NotificationContext);
